import { Vue } from "vue-property-decorator";
import { cartModel } from "@/pages/shopping-cart/shopping-cart.model";
import { setup } from "vue-class-component";
import { eff } from "@/core/utils/effect-ts-abbr";

export class PopupCart extends Vue {
    model = setup(() => cartModel);

    filterImages(
        images?: readonly (string | null | undefined)[] | null,
    ): readonly string[] {
        return eff.fn.pipe(images || [], eff.array.filterMap(eff.option.fromNullable));
    }
}
